// extracted by mini-css-extract-plugin
module.exports = {"list":"OrderHistory_list__2Tbd8","listItem":"OrderHistory_listItem__4eePF"};